import { render, staticRenderFns } from "./footer-btn.vue?vue&type=template&id=d8d2d47a&scoped=true&"
import script from "./footer-btn.vue?vue&type=script&lang=js&"
export * from "./footer-btn.vue?vue&type=script&lang=js&"
import style0 from "./footer-btn.vue?vue&type=style&index=0&id=d8d2d47a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d2d47a",
  null
  
)

export default component.exports